import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  LinearProgress,
  CircularProgress,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

export const FormEditShop = () => {
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setloadingSubmit] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    picture: null,
    active: 1,
    FiledDescription: 1,
    FiledTitle: 1,
    FiledImage: 1,
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    fetchDetails();
  }, [id]);
  const fetchDetails = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: api_Routes.ShopAds.GetOne + `/${id}`,
      });

      if (response) {
        setFormData({
          name: response.data.name || "",
          description: response.data.description || "",
          picture: null, 
          active: response.data.active ? 1 : 0,
          FiledDescription: response.data.FiledDescription ? 1 : 0,
          FiledTitle: response.data.FiledTitle ? 1 : 0,
          FiledImage: response.data.FiledImage ? 1 : 0,
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setFormData((prev) => ({
        ...prev,
        picture: files[0],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Handle radio changes
  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    setloadingSubmit(true);
    e.preventDefault();

    const formDataToSend = new FormData();
    for (let key in formData) {
      if (formData[key] !== null) {
        formDataToSend.append(key, formData[key]);
      }
    }

    try {
      const { response, message } = await Helper.Post({
        url: api_Routes.ShopAds.Edit + `/${id}`,
        data: formDataToSend,
        isFormData: true,
      });

      setloadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/Shop-ADS");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setloadingSubmit(false);
    }
  };

  if (loading) {
    return (
      <LinearProgress />
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        fullWidth
        margin="normal"
        label="Name"
        name="name"
        required
        autoComplete="off"
        value={formData.name}
        onChange={handleInputChange}
        variant="outlined"
      />

      <TextField
        fullWidth
        margin="normal"
        label="Description"
        name="description"
        multiline
        rows={2}
        autoComplete="off"
        value={formData.description}
        onChange={handleInputChange}
        variant="outlined"
      />

      <TextField
        fullWidth
        margin="normal"
        label="Upload Image"
        name="file"
        type="file"
        InputLabelProps={{ shrink: true }}
        onChange={handleInputChange}
        variant="outlined"
        inputProps={{
          accept: "image/*",
        }}
      />

      <div className="flex items-center justify-between gap-x-3">
        <div className="flex items-center justify-start gap-x-3">
          <FormLabel sx={{ fontWeight: "bold" }} component="legend">
            Image Required:
          </FormLabel>
          <RadioGroup
            name="FiledImage"
            value={formData.FiledImage}
            onChange={handleRadioChange}
            row
          >
            <FormControlLabel value="1" control={<Radio />} label="Yes" />
            <FormControlLabel value="0" control={<Radio />} label="No" />
          </RadioGroup>
        </div>


        <div className="flex items-center justify-start gap-x-3">
          <FormLabel sx={{ fontWeight: "bold" }} component="legend">
            Active:
          </FormLabel>
          <RadioGroup
            name="active"
            value={formData.active}
            onChange={handleRadioChange}
            row
          >
            <FormControlLabel value="1" control={<Radio />} label="Yes" />
            <FormControlLabel value="0" control={<Radio />} label="No" />
          </RadioGroup>
        </div>
      </div>
      <div className="flex items-center justify-between gap-x-3">
        <div className="flex items-center mt-2 justify-start gap-x-3">
          <FormLabel sx={{ fontWeight: "bold" }} component="legend">
            Description Required:
          </FormLabel>
          <RadioGroup
            name="FiledDescription"
            value={formData.FiledDescription}
            onChange={handleRadioChange}
            row
          >
            <FormControlLabel value="1" control={<Radio />} label="Yes" />
            <FormControlLabel value="0" control={<Radio />} label="No" />
          </RadioGroup>
        </div>

        <div className="flex items-center justify-start gap-x-3">
          <FormLabel sx={{ fontWeight: "bold" }} component="legend">
            Title Required:
          </FormLabel>
          <RadioGroup
            name="FiledTitle"
            value={formData.FiledTitle}
            onChange={handleRadioChange}
            row
          >
            <FormControlLabel value="1" control={<Radio />} label="Yes" />
            <FormControlLabel value="0" control={<Radio />} label="No" />
          </RadioGroup>
        </div>
      </div>
      {loadingSubmit ? (
        <Button
          fullWidth
          variant="contained"
          color="primary"
          sx={{
            display: "flex",
            marginTop: 2,
            width: "20%",
            marginX: "auto",
            fontWeight: "bold",
            justifyContent: "center",
          }}
        >
          <CircularProgress size={24} color="inherit" />
        </Button>
      ) : (
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          sx={{
            display: "block",
            marginTop: 2,
            width: "20%",
            marginX: "auto",
            fontWeight: "bold",
          }}
        >
          Submit
        </Button>
      )}
    </form>
  );
};
